import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LKModal from '../../desktop/components/Modal/Modal';
import AuthModal from '../../desktop/components/AuthModal/AuthModal';
import OfferCampaign from './OfferCampaign';
import { firstDealUserExists } from '../../actionCreators/offerCampaign';

function DesktopOfferModal(props) {
  const {
    renderOfferModal,
    userInfo,
    history,
    isDesktopPdp,
    productData,
    productOfferDetails,
    changeIsContinueClickedInOfferModalSuccess,
    dataLocale: { SELECT_OFFER },
  } = props;
  // isDesktopPdp : if offer modal in PDP page, should open Authmodal directly
  const [showAuthModal, triggerAuthModal] = useState(Boolean(isDesktopPdp));
  // State to maintain step or current screen of offer modal
  const [stepOfferCampaign, setStepOfferCampaign] = useState(1);

  useEffect(() => {
    // If loggedin user and open offer modal
    // then check if firstDeal form is filled or not by api request
    if (userInfo && userInfo.result && userInfo.result.login) {
      props.firstDealUserExists(userInfo.result.telephone);
    }
  }, [userInfo]);

  return (
    <React.Fragment>
      <LKModal
        showModal
        backdrop="static"
        dialogClassName="offer-modal"
        headerTitle={
          stepOfferCampaign === 1 ? (
            <div className="fs20 display-flex justify-content-center">{SELECT_OFFER}</div>
          ) : (
            <div></div>
          )
        }
        hideHandler={() => renderOfferModal(false)}
        size="medium"
      >
        <OfferCampaign
          isDesktop
          changeIsContinueClickedInOfferModalSuccess={changeIsContinueClickedInOfferModalSuccess}
          hasPlacedOrder={Boolean(userInfo && userInfo.result && userInfo.result.hasPlacedOrder)}
          history={history}
          isDesktopPdp={isDesktopPdp}
          setStepOfferCampaign={val => setStepOfferCampaign(val)}
          triggerAuthModal={val => triggerAuthModal(val)}
        />
      </LKModal>
      {showAuthModal && (
        <AuthModal
          allowSignUp
          isOffer
          hasPlacedOrder={Boolean(userInfo && userInfo.result && userInfo.result.hasPlacedOrder)}
          hideLogin={() => triggerAuthModal(false)}
          isDesktopPdp={isDesktopPdp}
          openTab="signup"
          productData={productData}
          productOfferDetails={productOfferDetails}
          renderOfferModal={renderOfferModal}
          userInfo={userInfo}
        />
      )}
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  userInfo: state.common.userInfo,
});

const mapDispatchToProps = dispatch => {
  return {
    firstDealUserExists: val => dispatch(firstDealUserExists(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopOfferModal);
